var $05b8b7b9837273cc$exports = {};
$05b8b7b9837273cc$exports = {
    "valid": `Wa\u{17C}ny`
};


export {$05b8b7b9837273cc$exports as default};
//# sourceMappingURL=pl-PL.module.js.map
